import { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '@sternum/web/components';
import { ThemeMode } from '@sternum/web/components/theme/main';
import { routes } from '@sternum/web/config/routes';
import { useGeneratePathWithCurrentClient } from '@sternum/web/features/auth/hooks';
import { namespaces } from '@sternum/web/services/i18n';

import { useMenu } from '../../hooks/useMenu';
import { MenuItemExpandableLinkVariant } from '../MenuItemExpandableLink/MenuItemExpandableLink.types';
import { MenuItemLink } from '../MenuItemLink';
import { MenuSection } from '../MenuSection';

import { MenuContent, MenuSectionWrapper } from './Menu.styles';

const makeIcon = (type: ComponentProps<typeof Icon>['type']) => <Icon type={type} size={18} />;

export function ComputeMenu() {
  const { t } = useTranslation(namespaces.appContainerWithMenu);
  const generatePath = useGeneratePathWithCurrentClient();
  const { isFullMenuVisible, isDashboardMenuVisible } = useMenu();

  const isShowFullMenuButtonVisible = !isFullMenuVisible && !isDashboardMenuVisible;
  const menuItemVariant: MenuItemExpandableLinkVariant = isFullMenuVisible ? 'expanded' : 'collapsed';
  const tooltipThemeMode: ThemeMode = isDashboardMenuVisible ? 'Dark' : 'Light';

  return (
    <MenuContent>
      <MenuSectionWrapper $isCollapsed={isShowFullMenuButtonVisible}>
        <MenuSection>
          <MenuItemLink
            tooltipThemeMode={tooltipThemeMode}
            variant={menuItemVariant}
            to={generatePath(routes.workloads.absolute)}
            icon={makeIcon('SpeedometerIcon')}
          >
            {t('menuItemDashboard')}
          </MenuItemLink>
          <MenuItemLink
            tooltipThemeMode={tooltipThemeMode}
            variant={menuItemVariant}
            to={generatePath(routes.workloadsAlerts.absolute)}
            icon={makeIcon('Activities2Icon')}
          >
            {t('menuAlerts')}
          </MenuItemLink>
          <MenuItemLink
            tooltipThemeMode={tooltipThemeMode}
            variant={menuItemVariant}
            to={generatePath(routes.integrations.cloud.absolute)}
            icon={makeIcon('ArrangeSquareIcon')}
          >
            {t('menuItemIntegrations')}
          </MenuItemLink>
        </MenuSection>
      </MenuSectionWrapper>
    </MenuContent>
  );
}
